import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { espacamento } from '../../styles/constants/sizes';

export const Header = styled.div`
  background-color: #f2f2f2;
  color: #828282;
  font-family: BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  border-bottom: 1px solid #ddd;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  filter: ${({ desfoque }) => (desfoque ? 'blur(2px)' : null)};

  @media screen and (min-width: 801px) {
    bottom: 0;
    top: 41px;
    width: ${(props) => (props.totem ? '280px' : '250px')};
    height: 100%;
    border-right: 1px solid #ddd;
  }
`;

export const Menu = styled.ul`
  padding-inline-start: 0;
  margin: 0;
  flex-direction: row;

  > div {
    background-color: #f2f2f2;

    @media screen and (max-width: 800px) {
      position: absolute;
      right: 0;
      border-left: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }
  }
`;

export const MenuHeader = styled.li`
  list-style: none;
  transition: ease-in-out .4s;
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    padding: 12.5px;
    color: inherit;
    display: flex;
    flex-direction: row;
    align-items: center;
    letter-spacing: 0;
    font-size: .8em;
  }

  img {
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 1em;
  }

  small {
    font-weight: normal;
  }

  span {
    line-height: 1.2;
    display: flex;
    flex-direction: column;
  }
`;

export const LinkHeader = styled(Link)`
  display: flex;
  align-items: center;
  color: inherit;

  :hover, :focus, :active {
    text-decoration: none;
    color: #f7c63a;
  }
`;

export const MenuItem = styled.li`
  list-style: none;

  a {
    padding: ${(props) => (props.totem ? '34px 18.5px' : '14px 10px')};
    color: inherit;
    font-size: ${(props) => (props.totem ? '1.05em' : '.72em')};
    font-weight: bold;
    letter-spacing: 1px;
    display: block;
    border-top: 1px solid #ddd;
    text-decoration: none;

    @media screen and (max-width: 800px) {
      width: 200px;
    }
  }

  svg {
    width: 28px;
    height: 28px;
    vertical-align: middle;
    fill: #828282;
    transform: translateY(-2px);
    transition: ease-in-out .4s;
    margin-right: .8em;
  }

  :hover {
    color: ${(tema) => tema.tema && tema.tema.letra};
    background-color: ${(tema) => tema.tema && tema.tema.fundo};

    svg {
      fill: ${(tema) => tema.tema && tema.tema.letra};
    }
  }
`;

export const MenuFooter = styled.li`
  list-style: none;
  position: absolute;
  bottom: 40px;
  width: 100%;
  padding-bottom: ${espacamento.pequeno}px;
  text-align: center;

  p {
    padding: 4px ${espacamento.pequeno}px;
    line-height: 1.8;
    font-size: .7em;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  img {
    max-width: 100%;
    vertical-align: middle;
    height: 15px;
  }


  @media screen and (max-width: 800px) {
    display: none;
  }
`;
